
let counter = 0;

export const PLAN_OP_EVENTS = Object.freeze(['handoff', 'box_substitute', 'box_combine', 'box_split']);

export function newGestureUid() {
  counter += 1;
  const rand = Math.random().toString(36).slice(2, 10);
  return `gpx-${Date.now().toString(36)}-${counter.toString(36)}-${rand}`;
}

const baseEvent = (order, userName) => ({
  event: 'handoff',
  uid: newGestureUid(),
  id: order && order.order ? order.order.id : null,
  increment_id: order && order.order ? order.order.increment_id : null,
  updated_at: order && order.order ? order.order.updated_at : null,
  time: new Date(),
  on_ex: 'on GPX',
  state: 'scanpack.rfp.default',
  name: userName || '',
});

export function handoffEvent({order, sealedBoxId, verifiedBoxId, userName} = {}) {
  return {
    ...baseEvent(order, userName),
    sealed_box_id: sealedBoxId == null ? null : sealedBoxId,
    verified_box_id: verifiedBoxId == null ? null : verifiedBoxId,
  };
}

export function firstVerifyEvent({order, verifiedBoxId, userName} = {}) {
  return handoffEvent({order, sealedBoxId: null, verifiedBoxId, userName});
}
